module.exports = __webpack_public_path__ + "img/branding.17a99926.png";